import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { IPD_COLORS, ipdCardSx } from './ipdColors';

const TONE_MAP = {
  default: IPD_COLORS.primary,
  teal:    IPD_COLORS.primary,
  mint:    IPD_COLORS.success.text,
  amber:   IPD_COLORS.warning.text,
  red:     IPD_COLORS.error.text,
  blue:    IPD_COLORS.info.text,
};

export default function IpdStatCard({ label, value, icon: Icon, tone = 'default', onClick, loading }) {
  const color = TONE_MAP[tone] || IPD_COLORS.primary;

  return (
    <Box
      onClick={onClick}
      sx={{
        ...ipdCardSx,
        color: IPD_COLORS.textPrimary,
        p: 2.5,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 110,
        '&:hover': onClick ? {
          borderColor: IPD_COLORS.primary,
          boxShadow: IPD_COLORS.shadow.cardHover,
        } : {},
      }}
    >
      {loading ? (
        <>
          <Skeleton variant="text" width="60%" sx={{ bgcolor: 'rgba(13, 35, 63, 0.08)' }} />
          <Skeleton variant="text" width="40%" height={40} sx={{ bgcolor: 'rgba(13, 35, 63, 0.08)' }} />
        </>
      ) : (
        <>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
            <Typography sx={{
              fontSize: 11,
              color: IPD_COLORS.textSecondary,
              textTransform: 'uppercase',
              letterSpacing: 0.8,
              fontWeight: 600,
              lineHeight: 1.3,
              pr: 1,
            }}>
              {label}
            </Typography>
            {Icon && (
              <Box sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: `${color}18`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                <Icon sx={{ color, fontSize: 20 }} />
              </Box>
            )}
          </Box>
          <Typography sx={{ fontSize: 32, fontWeight: 700, color: IPD_COLORS.textPrimary, lineHeight: 1 }}>
            {value ?? '—'}
          </Typography>
        </>
      )}
    </Box>
  );
}
